






























import Component from 'vue-class-component';
import Vue from 'vue'
import {Prop} from 'vue-property-decorator';
import {State} from 'vuex-class';
import {notify} from '@/modules/core/notification';

/**
 * Edición de una versión de la API
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ApiVersion extends Vue {
    public $refs: Vue['$refs'] & {
        form: {
            update (field: string, value: any): void,
        },
    }

    @State(state => state.appRouter.apiVersion)
    public apiVersion: ApiVersion

    /**
     * Controla la visibilidad del componente
     *
     * @var { boolean }
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    public saving = false

    /**
     * Guarda los cambios realizados
     */
    public async save () {
        this.saving = true
        await this.$store.dispatch('appRouter/saveApiVersion')

        this.$emit('input', false)
        this.saving = false
        notify('La versión de la API se ha actualizado correctamente')
    }

    public errorCaptured (error: Error) {
        this.saving = false
    }
}
